export default __webpack_public_path__ + "static/media/empty_network.55e2063d.svg";